<div class="MainContainer">
  &copy; {{ currentYear }} Aivor. All rights reserved.
</div>
